import { render, staticRenderFns } from "./AlphabetDictationIndex.vue?vue&type=template&id=6134c31e&scoped=true&"
import script from "./AlphabetDictationIndex.vue?vue&type=script&lang=js&"
export * from "./AlphabetDictationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6134c31e",
  null
  
)

export default component.exports